"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sjcl = require("sjcl");
var FE_CONN_TOKEN_AND_KEY_STORAGE_NAME_PREFIX = 'fe_connToken_key_';
function getStorageKey(userId) {
    return FE_CONN_TOKEN_AND_KEY_STORAGE_NAME_PREFIX + userId;
}
function setConnectionInfo(userId, connectionInfo) {
    var obj = {
        connectionToken: connectionInfo.connectionToken,
        cryptoKey: sjcl.codec.base64.fromBits(connectionInfo.cryptoKey),
    };
    localStorage.setItem(getStorageKey(userId), JSON.stringify(obj));
}
exports.setConnectionInfo = setConnectionInfo;
function getConnectionInfo(userId) {
    var obj;
    var str = localStorage.getItem(getStorageKey(userId));
    if (str) {
        obj = JSON.parse(str);
        if (!obj.connectionToken || !obj.cryptoKey) {
            throw new Error('Invalid connectionToken and/or cryptoKey');
        }
    }
    else {
        throw new Error('Invalid connectionToken and/or cryptoKey');
    }
    obj.cryptoKey = sjcl.codec.base64.toBits(obj.cryptoKey);
    return obj;
}
exports.getConnectionInfo = getConnectionInfo;
